import React from "react";

export default function Step10() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          10
        </div>
        <h1 className="">
          Você verá que na parte de baixo da tela, haverá um aviso dizendo que
          você precisa verificar seu perfil. <br />
          <b>
            Como em qualquer instituição financeira, você precisará informar
            alguns dados pessoais.
          </b>
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3617.jpg?alt=media&token=66480b52-0621-4418-bb0a-1435cc5e63bf"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
